
export const transform = {
  name: 'transform'
}

export const transformOrigin = {
  name: 'transform-origin'
}